import {LeadEmailSentEventDataApiDto, LeadEventApiDto} from "../../../api/model/rest";
import LeadEvent, {EmailEventSubtypeEnum, LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {option, Option} from "ts-option";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import {getIndividualContact} from "../../../store/view/contact";
import {store} from "../../../navigation/ReduxProvider";
import moment = require("moment");

export default class LeadEmailSentEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param data email send event data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadEmailSentEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadEmailSentEvent {
		const data = LeadEmailSentEventData.fromJson(json.data as LeadEmailSentEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadEmailSentEvent(json.id,
			json.leadId,
			LeadEventTypeEnum.EmailSent,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getActivityAdditionalMessages(): string[] {
		const messages = [];
		if (!!this.data.subject.length) {
			messages.push(`Subject: ${this.data.subject}`);
		}
		return messages;
	}

	getActivityType(): string {
		return `E-mail`
	}

	getActivityMessage(): string {
		let eventMessage: string;
		switch (this.data.subtype) {
			case EmailEventSubtypeEnum.FreeTextContactEmail:
				eventMessage = "E-mail to contact";
				break;
			case EmailEventSubtypeEnum.QuoteEmail:
				eventMessage = "Quote e-mail sent to contact";
				break;
			default:
				eventMessage = "E-mail to unknown receiver";
		}
		const receiver = this.data.receiverId.flatMap(r => getIndividualContact(r, store.getState()));
		const receiverName = receiver.isDefined ? ` - ${receiver.get.data.displayName()}` : "";
		const receiverMails =
			` (${this.data.receiverEmails.length ? this.data.receiverEmails.join(", ")
				: "unknown"})`;
		eventMessage = eventMessage + receiverName + receiverMails;
		return eventMessage;
	}
}

export class LeadEmailSentEventData {
	constructor(public readonly receiverId: Option<string>,
		public readonly receiverEmails: string[],
		public readonly subject: string,
		public readonly message: string,
		public readonly subtype: string) {}

	public static fromJson(json: LeadEmailSentEventDataApiDto): LeadEmailSentEventData {
		return new LeadEmailSentEventData(option(json.receiverId), json.receiverEmails, json.subject, json.message, json.subtype);
	}
}
